app.service("AdvertService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;

    const glazedAdverts = {
        bella: [
            "single_wall_unit_glazed_door_400",
            "single_wall_unit_glazed_door_500",
            "single_wall_unit_glazed_door_800",
            "single_wall_unit_glazed_door_1000",
            "double_wall_unit_glazed_doors_800",
            "double_wall_unit_glazed_doors_1000",
            "single_tall_wall_unit_glazed_door_400",
            "single_tall_wall_unit_glazed_door_500",
            "single_tall_wall_unit_glazed_door_800",
            "single_tall_wall_unit_glazed_door_1000",
            "double_tall_wall_unit_glazed_doors_800",
            "double_tall_wall_unit_glazed_doors_1000"
        ],
        hadley_thornbury_wilton: [
            "single_wall_unit_glazed_door_400",
            "single_wall_unit_glazed_door_500",
            "double_wall_unit_glazed_doors_800",
            "double_wall_unit_glazed_doors_1000",
            "single_tall_wall_unit_glazed_door_400",
            "single_tall_wall_unit_glazed_door_500",
            "double_tall_wall_unit_glazed_doors_800",
            "double_tall_wall_unit_glazed_doors_1000"
        ]
    }

    service.collectAdverts = function (product) {
        if (!product) {
            return null;
        }
        const adverts = {}
        if (product.solution_id === "kitchen_inrail") {
            adverts.rail = true;
        }

        const tags = product.tags ? product.tags : [];
        const siteRangeID = $rootScope.navigation_model.state_ids.site_range_id;

        if (product.model_id === "product_door" || product.model_id === "product_solution") {
            if (siteRangeID === "thornbury" || siteRangeID === "hadley") {
                adverts.aftercare_kit = true;
            }
        }
        if (product.model_id === "product_solution") {
            if (product.id === "boiler_unit_600") {
                adverts.boiler_housing = true;
            }
            if (siteRangeID === "bella") {
                if (glazedAdverts.bella.indexOf(product.id) !== -1) {
                    adverts.glazed = true;
                }
            } else if (siteRangeID === "hadley" || siteRangeID === "thornbury" || siteRangeID === "wilton") {
                if (glazedAdverts.hadley_thornbury_wilton.indexOf(product.id) !== -1) {
                    adverts.glazed = true;
                }
            }
            if (product.solution_id === "kitchen_inrail") {
                adverts.rail = true;
                if (tags.indexOf("tower") !== -1 || tags.indexOf("tall_tower") !== -1) {
                    adverts.profile_connectors = true;
                }
            }
        }

        return adverts;
    }
    
    service.preAddToCartAdverts = function (adverts, callback) {
        return []; //pre popups currently disabled
        if (!adverts || siteHelper.keyCount(adverts) === 0) {
            return [];
        }
        const popUpAdverts = [];
        for (let key in adverts) {
            let popUpAdvert = null;
            if (key === "glazed") {
                popUpAdvert = {
                    notice_txt: 'Please note The cabinet colour will be visible through the glass.',
                    paragraph_txt: 'Cabinets are only available in White, Grey, Anthracite and Urban Oak.\n\n' +
                        'Alternatively you can buy matching panels to make your own cabinet.',
                };
            } else if (key === "boiler_housing") {
                popUpAdvert = {
                    notice_txt: 'Product comes flatpack'
                };
            } else if (key === "profile_connectors") {
                popUpAdvert = {
                    notice_txt: 'Don\'t forget to order profile connectors AHUPC (Pk 10)',
                };
            }
            if (popUpAdvert) {
                popUpAdvert.callback = callback;
                popUpAdvert.close_txt = "Cancel";
                popUpAdvert.ok_txt = "Add to cart";
                popUpAdverts.push(popUpAdvert);
            }
        }
        return popUpAdverts;
    }

    service.onAddedToCartAdverts = function (adverts) {
        return []; //post popups currently disabled
        if (!adverts || siteHelper.keyCount(adverts) === 0) {
            return [];
        }
        const stateIDs = $rootScope.navigation_model.state_ids;
        adverts = siteHelper.simpleCloneObject(adverts);
        adverts = validateAdverts(adverts, true);
        const popUpAdverts = [];
        for (let key in adverts) {
            if (key === "aftercare_kit") {
                const siteRangeID = stateIDs.site_range_id;
                const thornburyHadley = siteRangeID === 'thornbury' ? "Thornbury" : "Hadley";
                const navigationIDs = $rootScope.navigation_manager.getStateIDs(-1, "component");
                switch (stateIDs.browse_id) {
                    case "solution":
                    case "site_range":
                        navigationIDs.component_id = "select_accessory";
                        break;
                    default:
                        navigationIDs.component_id = "component_accessory";
                        navigationIDs.tile_id = "polish";
                        navigationIDs.site_range_id = "thornbury";
                        break;
                }
                const href = $rootScope.navigation_manager.createNavigationModel(null, navigationIDs, true).href;
                popUpAdverts.push({
                    notice_txt: "Add an Aftercare Kit?",
                    paragraph_txt: "We noticed you have some " + thornburyHadley + " products in your cart but you have not added a " +
                        "Painted Door Aftercare Kit to your order. Would you like to add a Painted Door Aftercare Kit?",
                    callback: null,
                    cancel_callback: null,
                    href: href,
                    ok_txt: "Add kit",
                    close_txt: "Don't add",
                    hide_close: false
                })
            }
        }
        return popUpAdverts;
    }


    service.checkout_adverts = function (order) {
        let line;
        order = order ? order : $rootScope.model.order.current_order;
        const checkoutAdvertIDs = ["rail", "aftercare_kit"];
        let adverts = {};
        for (let i = 0; i < order.lines.length; i++) {
            line = order.lines[i];
            if (line.adverts) {
                for (let j = 0; j < checkoutAdvertIDs.length; j++) {
                    const checkoutAdvertID = checkoutAdvertIDs[j];
                    if (line.adverts[checkoutAdvertID] && !adverts[checkoutAdvertID]) {
                        adverts[checkoutAdvertID] = line;
                    }
                }
            }
        }

        adverts = validateAdverts(adverts, false, order);

        const checkoutAdverts = [];
        for (let key in adverts) {
            line = adverts[key];
            let checkoutAdvert = null;
            if (key === "rail") {
                checkoutAdvert = {
                    body: "We noticed you have some InRail products in your cart but you have not added any " +
                        "Rails to your order.",
                    cta: "Click here to add Rails, connectors and caps now",
                    navigation_ids: {browse_id: "component", component_id: "handle_rail", tab_id: "handleless_rail"}
                }
            } else if (key === "aftercare_kit") {
                const siteRangeID = line.site_range
                const colourID = line.colour
                if (siteRangeID && colourID) {
                    const thornburyHadley = siteRangeID === "thornbury" ? "Thornbury" : "Hadley";
                    checkoutAdvert = {
                        body: "We noticed you have some " + thornburyHadley + " products in your cart but you have not added a " +
                            "Painted Door Aftercare Kit to your order.",
                        cta: "Click here to add a Painted Door Aftercare Kit",
                        navigation_ids: {
                            browse_id: "component",
                            component_id: "component_accessory",
                            tile_id: "polish",
                            site_range_id: "thornbury"
                        }
                    }
                }
            }
            if (checkoutAdvert) {
                if (checkoutAdvert.navigation_ids) {
                    checkoutAdvert.href = $rootScope.navigation_manager.createNavigationModel(null, checkoutAdvert.navigation_ids, true).href;
                }
                checkoutAdverts.push(checkoutAdvert);
            }
        }
        return checkoutAdverts;
    }

    function validateAdverts(adverts, checkForDuplicates, order) {
        order = order ? order : $rootScope.model.order.current_order;
        for (let i = 0; i < order.lines.length; i++) {
            const line = order.lines[i];
            if (checkForDuplicates && i > 0) {
                if (line.adverts) {
                    for (let key in adverts) {
                        if (line.adverts[key]) {
                            delete adverts[key];
                        }
                    }
                }
            }
            if (adverts.rail) {
                if (line.parent_category_ids && line.parent_category_ids.includes("handleless_rail")) {
                    delete adverts.rail;
                }
            }
            if (adverts.aftercare_kit) {
                if (line.product_code && (line.product_code.substring(0, 2) === "PT" && line.product_code.slice(-3) === "PDK")) {
                    delete adverts.aftercare_kit;
                }
            }
        }
        return adverts;
    }

}]);